import { createStore } from 'vuex';

export const store = createStore({
  state () {
    return {
      filtros: [],
      filtroAplicados: {},
      ordemFiltros: [],
      advancedSettings: {}
    }
  },
  mutations: {
    setFiltros(state, filtros) {
      state.filtros = filtros
    },
    setFiltrosAplicados(state, filtros) {
      state.filtroAplicados = filtros
    },
    addFiltro(state, filtro) {
      state.filtros.push(filtro)
      if (!state.ordemFiltros.includes(filtro.filtro)) {
        state.ordemFiltros.push(filtro.filtro);
      }
    },
    addFiltroAplicado(state, filtro) {
      state.filtroAplicados[filtro.filtro] = filtro.valor
    },
    removeFiltro(state, filtro) {
      state.filtros = state.filtros.filter(f => f.filtro !== filtro)
      state.ordemFiltros = state.ordemFiltros.filter(f => f !== filtro);
      state.filtroAplicados = Object.keys(state.filtroAplicados).reduce((acc, key) => {
        if (key !== filtro) {
          acc[key] = state.filtroAplicados[key]
        }
        return acc
      }, {})
    },
    removeFiltroAplicado(state, filtro) {
      state.filtroAplicados = Object.keys(state.filtroAplicados).reduce((acc, key) => {
        if (key !== filtro) {
          acc[key] = state.filtroAplicados[key]
        }
        return acc
      }, {})
    },
    limparFiltros (state) {
      state.filtros = []
      state.filtroAplicados = {}
      state.ordemFiltros = [];
      state.advancedSettings = {}
    },
    setAdvancedSettings(state, settings) {
      state.advancedSettings = settings
    },
    addAdvancedSetting(state, setting) {
      state.advancedSettings[setting.filtro] = setting.value
    },
    removeAdvancedSetting(state, filtro) {
      const { [filtro]:_, ...rest } = state.advancedSettings;
      state.advancedSettings = rest;
    }
  }
})
